// Navbar.jsx
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";
import COLORS from "../constants/colors";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    navigate("/");
  };

  const navLinks = [
    { to: "/films", label: "FILMS" },
    { to: "/dessins", label: "DESSINS" },
    { to: "/illustrations", label: "ILLUSTRATIONS" },
    { to: "/animations", label: "ANIMATIONS" },
    { to: "/contact", label: "CONTACT" },
  ];

  const socialLinks = [
    { href: "https://www.instagram.com/oscar_mygrateur/", icon: <FaInstagram size={24} /> },
    { href: "https://www.linkedin.com/in/oscarmasoyguellrivet/", icon: <FaLinkedin size={24} /> },
  ];

  return (
    <nav style={{ backgroundColor: COLORS.primary }}>
      {/* Logo */}
      <div className="nav-name">
        <Link
          to="/"
          className="name-text"
          style={{
            "--link-color": COLORS.secondary,
            "--link-hover-bg": COLORS.secondary,
            "--link-hover-color": COLORS.primary,
          }}
        >
          OSCAR MASO Y GUËLL RIVET
        </Link>
      </div>

      {/* Burger menu pour mobile */}
      <div className="burger" onClick={toggleMenu}>
        {menuOpen ? (
          <FaTimes size={28} color={COLORS.secondary} />
        ) : (
          <FaBars size={28} color={COLORS.secondary} />
        )}
      </div>

      {/* Liens de navigation */}
      <div className={`nav-links ${menuOpen ? "show" : ""}`}>
        {navLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={location.pathname === link.to ? "active" : ""}
            style={{
              "--link-color": COLORS.secondary,
              "--link-hover-bg": COLORS.secondary,
              "--link-hover-color": COLORS.primary,
            }}
            onClick={() => setMenuOpen(false)} // ferme le menu quand on clique
          >
            {link.label}
          </Link>
        ))}

        {/* Séparateurs */}
        
        <div 
          className="separator"
          style={{
            borderLeft: `1px solid ${COLORS.secondary}`,
            height: "30px",
            marginRight: "-20px",
                          "--link-color": COLORS.secondary,
              "--link-hover-bg": COLORS.secondary,
              "--link-hover-color": COLORS.primary,
          }}
        />
        <div
          className="separator"
          style={{
            borderLeft: `1px solid ${COLORS.secondary}`,
            height: "30px",
                          "--link-color": COLORS.secondary,
              "--link-hover-bg": COLORS.secondary,
              "--link-hover-color": COLORS.primary,
          }}
        />

        {/* Bouton déconnexion */}
        {location.pathname === "/admin" && (
          <button
            className="loggout-btn"
            style={{
              "--btn-bg": COLORS.secondary,
              "--btn-color": COLORS.primary,
              "--btn-hover-bg": COLORS.primary_hover,
              "--btn-hover-color": COLORS.secondary,
            }}
            onClick={handleLogout}
          >
            DÉCONNEXION
          </button>
        )}

        {/* Icônes réseaux sociaux */}
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
            style={{
              "--icon-color": COLORS.secondary,
              "--icon-hover-color": COLORS.primary,
              "--icon-bg": "transparent",
              "--icon-hover-bg": COLORS.secondary,
            }}
          >
            {link.icon}
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Navbar;
